import { DateTime } from "luxon";
import { isVersionUK } from "../services/versionService";

const BASE_DATE_FORMAT = "yyyy-MM-dd'T'hh:mm:ss";

export const localeDateFormat = isVersionUK ? "dd/MM/yyyy" : "MM/dd/yyyy";

export const getDateTime = (date, initFormat = BASE_DATE_FORMAT) => {
    if (!date) return null;
    if (date instanceof DateTime) return date;
    if (date instanceof Date) return DateTime.fromJSDate(date);
    if (typeof date !== "string") return null;

    return DateTime.fromFormat(date, initFormat);
};

export const formatTo = (date, format, initFormat = BASE_DATE_FORMAT) => {
    if (!date) return "";

    let dt;

    if (/^\d{4}-\d{2}-\d{2}T/.test(date)) {
        dt = DateTime.fromISO(date, { zone: "utc" });
    } else if (date instanceof DateTime) {
        dt = date;
    } else if (date instanceof Date) {
        dt = DateTime.fromJSDate(date);
    } else if (typeof date === "string") {
        dt = DateTime.fromFormat(date, initFormat);
    } else {
        return "";
    }

    return dt.isValid ? dt.toFormat(format) : "";
};

export const addOneDay = (dateString) => {
    const date = DateTime.fromISO(dateString);
    const newDate = date.plus({ days: 1 });
    return newDate.toISODate();
};

export const getWeekDay = (dateString) => {
    if (!dateString) return "";
    const dt = DateTime.fromISO(dateString);
    return dt.isValid ? dt.toFormat("EEE") : "";
};

export const findActiveTerm = (terms) => {
    const today = DateTime.now().startOf("day");

    return terms.reduce((closest, term) => {
        const start = DateTime.fromISO(term.start);
        const end = DateTime.fromISO(term.end);

        const dist = Math.max(0, Math.max(start.diff(today).milliseconds, today.diff(end).milliseconds));

        const cs = DateTime.fromISO(closest.start);
        const ce = DateTime.fromISO(closest.end);
        const closestDist = Math.max(0, Math.max(cs.diff(today).milliseconds, today.diff(ce).milliseconds));

        return dist < closestDist ? term : closest;
    });
};

export const isDateInPast = (date, initFormat = BASE_DATE_FORMAT) => {
    if (!date) return false;

    const dt = date instanceof DateTime
        ? date
        : date instanceof Date
            ? DateTime.fromJSDate(date)
            : DateTime.fromISO(date);

    if (!dt?.isValid) return false;

    return dt.startOf("day") < DateTime.now().startOf("day");
};
